import { useEffect, useState } from "react";
import type { MainTab } from "../../models/types";
import {
  IconGame,
  IconHome,
  IconNews,
  IconPeople,
} from "./Icons";

const INTRO_CONTENT: Record<
  MainTab,
  { Icon: typeof IconHome; headline: string; body: string; cta: string }
> = {
  home: {
    Icon: IconHome,
    headline: "Welcome home",
    body: "Your starting point: a warm hello, quick jumps into the tree, map, faces and games, plus whose birthday is coming up next.",
    cta: "Let's go",
  },
  family: {
    Icon: IconPeople,
    headline: "Find anyone, three ways",
    body: "Tap the picker up top to switch views — the Tree shows how everyone connects, the Map shows who lives where, and the Directory lists every face A to Z.",
    cta: "Meet the family",
  },
  play: {
    Icon: IconGame,
    headline: "Learn the family, the fun way",
    body: "Pick your vibe — meet the fam, take on a challenge, or jump into trivia night — then chase a top spot on the leaderboard.",
    cta: "Start playing",
  },
  news: {
    Icon: IconNews,
    headline: "What's happening",
    body: "Announcements, upcoming birthdays, and family events — all in one feed. Tap + to suggest an event for admin approval.",
    cta: "Read the news",
  },
};

export function TabIntroModal({
  tab,
  onContinue,
}: {
  tab: MainTab;
  onContinue: () => void;
}) {
  const content = INTRO_CONTENT[tab];
  const [showHero, setShowHero] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [showCta, setShowCta] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowHero(true), 80);
    const t2 = setTimeout(() => setShowCopy(true), 280);
    const t3 = setTimeout(() => setShowCta(true), 480);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <div className="tab-intro-full" role="dialog" aria-modal="true" aria-labelledby="tab-intro-headline">
      <div className="tab-intro-inner">
        <div className={`tab-intro-hero ${showHero ? "visible" : ""}`}>
          <content.Icon />
        </div>
        <div className={`tab-intro-copy ${showCopy ? "visible" : ""}`}>
          <h2 id="tab-intro-headline" className="title-serif">
            {content.headline}
          </h2>
          <p>{content.body}</p>
        </div>
        <div className={`tab-intro-cta ${showCta ? "visible" : ""}`}>
          <button type="button" className="btn-primary" onClick={onContinue}>
            {content.cta}
          </button>
        </div>
      </div>
    </div>
  );
}
